import type { RelationshipWithGuest } from './types';

/**
 * 管理者向け：宿泊者との関係の選択肢（日本語固定）
 */
export const ADMIN_RELATIONSHIP_OPTIONS: { value: RelationshipWithGuest; title: string }[] = [
    { value: 'person_himself', title: '本人' },
    { value: 'family', title: '家族' },
    { value: 'friends', title: '友達' },
    { value: 'colleague', title: '同僚' },
    { value: 'others', title: 'その他' },
];
